import api from '../api';
import { toastSuccess, toastError } from '../../toasts';

class GroupService {
  static async create(data) {
    try {
      if (!data || Object.keys(data).length === 0) return;

      const response = await api.post('grupo-produto/criar', data);

      toastSuccess('Grupo cadastrado');
      return response.data;
    } catch (error) {
      toastError('Não foi possivel cadastrar grupo');
      console.log(error);
    }
  }

  static async delete(id = '') {
    try {
      if (!id) return false;

      await api.delete(`grupo-produto/${id}`);
      toastSuccess('Grupo foi apagado');

      return true;
    } catch (error) {
      toastError('Não foi possivel apagar o grupo');
      console.log(error);
      return false;
    }
  }
}

export { GroupService };
